import { Card, CardContent, Typography } from '@eye-able/ui';
import { T } from '@/i18n/T';

function NoIssuesPlaceholder() {
  return (
    <Card>
      <CardContent className='eye:p-s'>
        <Typography className='eye:text-grey-120'>
          <T k='noIssues' />
        </Typography>
      </CardContent>
    </Card>
  );
}

export { NoIssuesPlaceholder };
